import { useEffect } from 'react'
import { usePlanner } from '../contexts/PlannerContext'
import { fetchGroceryList } from '../services/plannerService'


export default function useMealPlanner() {
  const {
    activePlan,
    setActivePlan,
    plans,         // list of all plans
    planMeals,     // ✅ correct key from context
    loading,
    fetchAll,
    addToPlan,
    removeFromPlan,
    createPlan,
  } = usePlanner()

  useEffect(() => {
    fetchAll()
  }, [fetchAll])

  return {
    activePlan,
    setActivePlan,
    plans,
    planMeals,         // ✅ used directly in MealPlanner.jsx
    loading,
    fetchAll,          // ✅ used in MealPlanner.jsx to refresh plans
    addEntry: addToPlan,
    removeEntry: removeFromPlan,
    createPlan,
    getGroceryList: fetchGroceryList,
  }
}